(() => {
  const modalContent = document.getElementById('quick-add-modal-content');
  if (!modalContent) return;

  const adaptDirectProductPanel = () => {
    const directPanel = modalContent.querySelector('.product-details__direct-panel');
    if (!directPanel || directPanel.dataset.quickAddAdapted === 'true') return;

    directPanel.dataset.quickAddAdapted = 'true';
    directPanel.classList.add('group-block', 'sp-quick-add-direct-panel');

    directPanel
      .querySelector('.product-details__direct-title')
      ?.classList.add('view-product-title', 'sp-quick-add-direct-title');

    directPanel
      .querySelector('.product-details__direct-actions')
      ?.classList.add('buy-buttons-block', 'sp-quick-add-direct-actions');

    directPanel
      .querySelector('.product-details__made-to-order-form')
      ?.classList.add('group-block', 'sp-quick-add-form-group');

    directPanel
      .querySelector('.product-details__purchase-support')
      ?.classList.add('group-block', 'sp-quick-add-form-group');
  };

  const observer = new MutationObserver(adaptDirectProductPanel);
  observer.observe(modalContent, { childList: true, subtree: true });

  adaptDirectProductPanel();
})();
